import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';
import ItemList from 'flarum/common/utils/ItemList';
export default () => {
  // add push notification column
  extend(NotificationGrid.prototype, 'notificationMethods', function(items: ItemList) {
    items.add('push', {
      name: 'push',
      icon: 'fas fa-comments',
      label: app.translator.trans('core.forum.settings.notify_by_push_heading'),
    });
  });
}
